import { combineReducers } from '@reduxjs/toolkit';

import lifeInformationAndPayReducer from '../LifeInformationAndPay/Action/reducer';

export const lifeInsuReducers = combineReducers({
  informationAndPay: lifeInformationAndPayReducer,
} as any);
